import {api} from '../../helpers';

function fetchAddressVerifications(params) {
  return api.get('/users/address-lookup', {params}).then(res => res.data);
}

function fetchAddressVerification(id, params) {
  const queryParams = new URLSearchParams(params);
  return api
    .get(`/users/address-lookup/${id}?${queryParams}`)
    .then(res => res.data);
}

function performVerification(params) {
  return api.post('/users/address-lookup', params).then(res => res.data);
}

function fetchBatchAddressVerifications(params) {
  return api.get('/users/address-lookup/batch', {params}).then(res => res.data);
}

function performBatchVerification(params) {
  return api.post('/users/address-lookup/batch', params).then(res => res.data);
}

function fetchBatchVerificationCount(id) {
  return api.get(`/users/address-lookup/batch/${id}`).then(res => res.data);
}

function fetchAddressVerificationSummary(params = {}) {
  return api
    .get(`/users/address-lookup/summary`, {params})
    .then(res => res.data);
}

function fetchStates() {
  return fetch('https://api.dojah.io/api/v1/general/states')
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch states');
      return response.json();
    })
    .then(data =>
      data.states.map(state => ({
        value: state,
        label: state,
      })),
    );
}

function fetchLgas(state) {
  return fetch(`https://api.dojah.io/api/v1/general/states/lgas?state=${state}`)
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch LGAs');
      return response.json();
    })
    .then(data =>
      data.lgas.map(lga => ({
        value: lga,
        label: lga,
      })),
    );
}

export {
  fetchAddressVerifications,
  performVerification,
  fetchBatchAddressVerifications,
  performBatchVerification,
  fetchBatchVerificationCount,
  fetchAddressVerification,
  fetchAddressVerificationSummary,
  fetchStates,
  fetchLgas,
};
